import axios from "axios";
import { useEffect, useState } from "react";
import { FaCheckCircle, FaTimes } from "react-icons/fa";
// import { getCountryCallingCode } from "libphonenumber-js";
// import countryToCurrency from "country-to-currency";
import { GetandCreateLinkUnit } from "../../../../../services/ProductService/UnitSettings/UnitSettings";
import { CountryAPI, GetAndCreateRfq, GetDefaultUnitId, GetSpecificRfq, UpdateAndDeleteRfq } from "../../../../../services/ProductService/AllProductList/AllProductServices";
import SelectSACModal from "../../../../../components/modals/SeriveModals/AddServicesModals/SelectSACModal";

export default function CreateRfqModal ({ isOpen, onClose, onSuccess, onUpdate }){

    const [countryCode, setCountryCode] = useState([])
    const [units, setUnits] = useState(null)
    const [selectedCountry, setSelectedCountry] = useState('')
    const [selectedCountryCode, setSelectedCountryCode] = useState('')
    const [dialCode, setDialCode] = useState('91')
    const [currency, setCurrency] = useState('-')
    const [showDropdown, setShowDropdown] = useState(true);
    const [negotiable, setNegotiable] = useState(null);
    const [notNegotiable, setNotNegotiable] = useState(null);
    const [PhoneNumber, setPhoneNumber] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const [success, setSuccess] = useState('');

    const [newRfqDatas, setNewRfqDatas] = useState({
        "product_name": "",
        "country": "IND",
        "mobile_number": "",
        "email": "",
        "company_name": "",
        "hsn_code_id": null,
        "quantity": null,
        "unit_id": null,
        "destination_port": "",
        "inco_term": "",
        "payment_term": "",
        "target_price": null,
        "is_negotiable": null,
        "preferred_source_country": "",
        "attachment": "",
        "short_description": ""
    })

    const countryFlages = async () => {
        try {
            const response = await CountryAPI('GET',{});
            setCountryCode(response.data.data);
        } catch (error) {
            console.error("Error fetching country data:", error);
        }
    };

    const getCountryCurrency = (countryCode) => {
        // return countryToCurrency[countryCode] || "Currency not found";
    };

    const handleSelectedCountryCode = (country) => {
        setSelectedCountry(country.country_name);
        setSelectedCountryCode(country.country_code);
        // const newDialCode = getCountryCallingCode(country.country_code);
        // setDialCode(newDialCode);
        setCurrency(getCountryCurrency(country.country_code));
        // Update phone number if it exists
        if (PhoneNumber) {
            setNewRfqDatas(prev => ({
                ...prev,
                // mobile_number: `+${newDialCode} ${PhoneNumber}`,
                country: country.country_name
            }));
        } else {
            setNewRfqDatas(prev => ({
                ...prev,
                country: country.country_name
            }));
        }
    };

    const handleSelectHSNCode = async (selectedHSN) => {
        if (!selectedHSN) return;

        try {
            setNewRfqDatas((prev) => ({
                ...prev,
                hsn_code_id: selectedHSN.id,
            }));

            // Fetch linked HSN unit details
            const response = await GetandCreateLinkUnit('GET', {});
            const specifiedLinkHSN = response.data.find(
                (item) => item.hsn_code_display === selectedHSN.code
            );

            if (specifiedLinkHSN && specifiedLinkHSN.default_unit_display) {
                // Fetch unit ID based on the default unit name
                const responseUnitId = await GetDefaultUnitId('GET', {});
                const unit = responseUnitId.data.find(
                    (item) => item.unit_name === specifiedLinkHSN.default_unit_display
                );

                if (unit) {
                    setUnits(unit.unit_name);
                    setNewRfqDatas((prev) => ({
                        ...prev,
                        unit_id: unit.uint_id, // Assign the default unit ID
                    }));
                } else {
                    console.warn("Unit not found for the default unit display:", specifiedLinkHSN.default_unit_display);
                }
            }
        } catch (error) {
            console.error("Error fetching HSN unit details:", error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'mobile_number') {
            setNewRfqDatas((prev) => ({
                ...prev,
                [name]: `+${dialCode} ${value}`
            }));
        } else {
            setNewRfqDatas((prev) => ({
                ...prev,
                [name]: value
            }));
        }
    };

    const handleNegotiable = (e) => {
        const { name } = e.target
        if (name === 'negotiable') {
            setNegotiable(true)
            setNotNegotiable(false)
            setNewRfqDatas((prev) => ({
                ...prev,
                is_negotiable: true,
            }));
        } else {
            setNegotiable(false)
            setNotNegotiable(true)
            setNewRfqDatas((prev) => ({
                ...prev,
                is_negotiable: false,
            }));
        }
    }

    const handleFileChange = (e) => {
        console.log(e.target.files[0].name);
        setNewRfqDatas((prev) => ({
            ...prev,
            attachment: e.target.files[0].name,
        }));
    }

    const handleClose = () => {
        setNewRfqDatas({
            "product_name": "",
            "country": "",
            "mobile_number": "",
            "email": "",
            "company_name": "",
            "hsn_code_id": null,
            "quantity": null,
            "unit_id": null,
            "destination_port": "",
            "inco_term": "",
            "payment_term": "",
            "target_price": null,
            "is_negotiable": null,
            "preferred_source_country": "",
            "attachment": "",
            "short_description": ""
        })
        onClose()
    }

    const handleSubmit = async (value) => {

        const requiredFields = [
            "product_name",
            "country",
            "mobile_number",
            "email",
            "company_name",
            "hsn_code_id",
            "quantity",
            "unit_id",
            "destination_port",
            "inco_term",    
            "payment_term",
            "target_price",
            "is_negotiable",
            "preferred_source_country",
            "attachment",
            "short_description"
        ];

        if (value === 'update') {
            try {
                const response = await UpdateAndDeleteRfq('PATCH', onUpdate, newRfqDatas);
                if (response.data) {
                    setSuccess('RFQ Updated Successfully!!!');
                    setTimeout(() => {
                        setSuccess('')
                    }, 2000)
                    onSuccess()
                }
            } catch (error) {
                console.error("Error submitting RFQ:", error);
            }
        } else {
            const missingFields = requiredFields.filter(field => newRfqDatas[field] === null || newRfqDatas[field] === undefined || newRfqDatas[field] === "");

            if (missingFields.length > 0) {
                const formattedMissingFields = missingFields.map(field => {
                    return field.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
                });
                setErrorMessage(`Please fill the following fields: ${formattedMissingFields.join(', ')}`);
            } else {
                try {
                    const response = await GetAndCreateRfq('POST', newRfqDatas);
                    if (response.data) {
                        setSuccess('RFQ Created Successfully!!!');
                        setTimeout(() => {
                            setSuccess('')
                        }, 2000)
                        onSuccess()
                    }
                } catch (error) {
                    console.error("Error submitting RFQ:", error);
                }
            }
        }
    };

    const getsingleRfq = async (id) => {
        const response = await GetSpecificRfq('GET', id, {})
        setNewRfqDatas(response.data) // Assign the default unit ID
        const datas = response.data.mobile_number.split(' ')
        setPhoneNumber(datas[1])
        setDialCode(datas[0])
    }

    useEffect(() => {
        if (onUpdate) {
            getsingleRfq(onUpdate)
        }
        countryFlages()
    }, [onUpdate])


    return (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
            {success ? (
                <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full relative">
                    <div className="flex flex-col items-center">
                        <FaCheckCircle className="text-6xl text-green-500 mb-3" />
                        <p className="text-lg font-semibold">{success} ✅</p>
                        <button
                            className="bg-blue-500 text-white px-6 py-2 mt-4 rounded-lg"
                            onClick={handleClose} // Close the modal when clicked
                        >
                            Done
                        </button>
                    </div>
                </div>)
                :
                (<div className="bg-white p-6 rounded-3xl w-2/3">
                    <div className="flex justify-between items-center border-b pb-3">
                        <h2 className="text-xl font-semibold">Create Enquiries</h2>
                        <button onClick={onClose} className="text-gray-500 hover:text-gray-800">
                            <FaTimes size={20} />
                        </button>
                    </div>

                    <div className="overflow-auto h-[450px] flex flex-col">
                        <div className="grid grid-cols-3 gap-8 my-4">

                            {/* Product Name */}
                            <div className="flex flex-col gap-4">
                                <label className="block font-bold text-gray-500">Product Name <span className="text-red-600">*</span> </label>
                                <input type="text" name="product_name" placeholder="Enter product name" className="w-full border-2 p-2 rounded-xl outline-none"
                                    value={newRfqDatas.product_name ? newRfqDatas.product_name : ""}
                                    onChange={(e) => handleChange(e)} />
                            </div>

                            {/* Country Selector */}
                            <div className="flex flex-col gap-4">
                                <label className="block font-bold text-gray-500">Country <span className="text-red-600">*</span> </label>
                                <div className="flex items-center gap-2 border-2 p-2 rounded-xl">
                                    <div className="w-10 flex items-center justify-center">
                                        {selectedCountryCode ? (
                                            <img
                                                src={`https://flagcdn.com/w40/${selectedCountryCode.toLowerCase()}.png`}
                                                alt="Country Flag"
                                                className="w-8 h-6"
                                            />
                                        ) : (
                                            "-"
                                        )}
                                    </div>
                                    <div className="border-r-2 border-gray-300 h-6 mx-2"></div>
                                    <div onClick={() => setShowDropdown(!showDropdown)}>
                                        <select
                                            name="country"
                                            className="w-full border-none outline-none cursor-pointer"
                                            value={newRfqDatas.country || ""}
                                            onChange={(e) => {
                                                const selected = countryCode.find(
                                                    (country) => country.country_name === e.target.value
                                                );
                                                if (selected) handleSelectedCountryCode(selected);
                                            }}
                                        >
                                            <option value="">Select Country</option>
                                            {countryCode.map((country) => (
                                                <option key={country.country_code} value={country.country_name}>
                                                    {country.country_name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>

                            {/* Mobile Number */}
                            <div className="flex flex-col gap-4">
                                <label className="block font-bold text-gray-500">Mobile Number <span className="text-red-600">*</span> </label>
                                <div className="flex items-center gap-1">
                                    <div>{dialCode ? `${dialCode}` : ''}</div>
                                    <input type="number" name="mobile_number" placeholder="Enter mobile number" className="w-full border-2 p-2 rounded-xl outline-none"
                                        value={PhoneNumber}
                                        onChange={(e) => handleChange(e)} />
                                </div>
                            </div>

                            {/* Email */}
                            <div className="flex flex-col gap-4">
                                <label className="block font-bold text-gray-500">Email <span className="text-red-600">*</span> </label>
                                <input type="email" name="email" placeholder="Enter email address" className="w-full border-2 p-2 rounded-xl outline-none"
                                    value={newRfqDatas.email ? newRfqDatas.email : ""}
                                    onChange={(e) => handleChange(e)} />
                            </div>

                            {/* Company Name */}
                            <div className="flex flex-col gap-4">
                                <label className="block font-bold text-gray-500">Your Company Name <span className="text-red-600">*</span> </label>
                                <input type="text" name="company_name" placeholder="Enter Company Name" className="w-full border-2 p-2 rounded-xl outline-none"
                                    value={newRfqDatas.company_name ? newRfqDatas.company_name : ""}
                                    onChange={(e) => handleChange(e)} />
                            </div>


                            {/* HSN Code */}
                            <div className="flex flex-col gap-4">
                                <label className="block font-bold text-gray-500">HSN Code</label>
                                <SelectSACModal onCreateRfq={true} onSelectedHSN={handleSelectHSNCode} />
                            </div>

                            {/* Quantity and Unit */}
                            <div className="flex items-center gap-2">
                                <div className="flex flex-col gap-4">
                                    <label className="block font-bold text-gray-500">Quantity <span className="text-red-600">*</span> </label>
                                    <input type="number" name="quantity" placeholder="Enter quantity" className="w-full border-2 p-2 rounded-xl outline-none"
                                        value={newRfqDatas.quantity ? newRfqDatas.quantity : ""}
                                        onChange={(e) => handleChange(e)} />
                                </div>
                                <div className="flex flex-col gap-4">
                                    <label className="block font-bold text-gray-500">Unit <span className="text-red-600">*</span> </label>
                                    <select className="w-full border-2 p-2 rounded-xl outline-none h-fit" name="unit_id">
                                        <option value="">Select Option</option>
                                        <option value="">{newRfqDatas.unit ? newRfqDatas.unit : "" || units}</option>
                                    </select>
                                </div>
                            </div>

                            {/* Destination Port */}
                            <div className="flex flex-col gap-4">
                                <label className="block font-bold text-gray-500">Destination Port <span className="text-red-600">*</span> </label>
                                <input type="text" name="destination_port" placeholder="Enter Destination Port" className="w-full border-2 p-2 rounded-xl outline-none"
                                    value={newRfqDatas.destination_port ? newRfqDatas.destination_port : ""}
                                    onChange={(e) => handleChange(e)} />
                            </div>

                            {/* Inco Term */}
                            <div className="flex flex-col gap-4">
                                <label className="block font-bold text-gray-500">Inco Term <span className="text-red-600">*</span> </label>
                                <input type="text" name="inco_term" placeholder="Enter Inco Term" className="w-full border-2 p-2 rounded-xl outline-none"
                                    value={newRfqDatas.inco_term ? newRfqDatas.inco_term : ""}
                                    onChange={(e) => handleChange(e)} />
                            </div>

                            {/* Target Price */}
                            <div className="flex flex-col gap-4">
                                <label className="block font-bold text-gray-500">Target Price</label>
                                <div className="flex items-center border-2 rounded-xl">
                                    <input type="text" name="target_price" placeholder="Enter target price" className="w-full p-2 mx-2 outline-none"
                                        value={newRfqDatas.target_price ? newRfqDatas.target_price : ""}
                                        onChange={(e) => handleChange(e)} />
                                    <span className="px-3 ">{currency} </span>
                                </div>
                            </div>


                            {/* Negotiable */}
                            <div className="flex flex-col gap-4">
                                <span className="font-bold text-gray-500">Negotiable <span className="text-red-600">*</span> </span>
                                < div className="flex gap-5 mx-10 items-center justify-center">
                                    <label className="flex items-center text-lg gap-3">
                                        <input type="radio" name="negotiable" className="scale-125"
                                            checked={newRfqDatas.is_negotiable === true || negotiable === true}
                                            onClick={(e) => handleNegotiable(e)}
                                        /> Yes
                                    </label>
                                    <label className="flex items-center text-lg gap-3">
                                        <input type="radio" name="not_negotiable" className="scale-125"
                                            checked={newRfqDatas.is_negotiable === false || notNegotiable === true}
                                            onClick={(e) => handleNegotiable(e)}
                                        /> No
                                    </label>
                                </div>
                            </div>

                            {/* Payment Termm */}
                            <div className="flex flex-col gap-4">
                                <label className="block font-bold text-gray-500">Payment Term <span className="text-red-600">*</span> </label>
                                <input type="text" name="payment_term" placeholder="Enter Payment Term" className="w-full border-2 p-2 rounded-xl outline-none"
                                    value={newRfqDatas.payment_term ? newRfqDatas.payment_term : ""}
                                    onChange={(e) => handleChange(e)} />
                            </div>

                            {/* Preffered Source From Country */}
                            <div className="flex flex-col gap-4">
                                <label className="block font-bold text-gray-500">Prefered Source From Country <span className="text-red-600">*</span> </label>
                                <input type="text" name="preferred_source_country" placeholder="Enter product prefered country" className="w-full border-2 p-2 rounded-xl outline-none"
                                    value={newRfqDatas.preferred_source_country ? newRfqDatas.preferred_source_country : ""}
                                    onChange={(e) => handleChange(e)} />
                            </div>

                            {/* file Attachement */}
                            <div className="flex flex-col gap-4">
                                <label className="block font-bold text-gray-500">File Attachement <span className="text-red-600">*</span> </label>
                                <input type="file" name="attachement" placeholder="Enter product prefered country" className="w-full border-2 p-2 rounded-xl outline-none"
                                    // value={newRfqDatas.attachment ? newRfqDatas.attachment : ""}
                                    onChange={(e) => handleFileChange(e)} />
                            </div>
                        </div>

                        {/* Short Descriprtion */}
                        <div className="flex flex-col gap-4">
                            <label className="block font-bold text-gray-500">Short Description <span className="text-red-600">*</span> </label>
                            <textarea type="text" name="short_description" placeholder="Enter product prefered country" className="w-full h-40 border-2 p-2 rounded-xl outline-none"
                                value={newRfqDatas.short_description ? newRfqDatas.short_description : ""}
                                onChange={(e) => handleChange(e)} />
                        </div>
                    </div>
                    <div className="text-red-600 my-3 px-3">
                        {errorMessage && <p>{errorMessage}</p>}
                    </div>
                    {onUpdate ? (<div className="m-5 flex justify-end">
                        <button className="px-5 py-2 bg-blue-500 text-white rounded"
                            onClick={() => handleSubmit('update')}>Update</button>
                    </div>) : (<div className="m-5 flex justify-end">
                        <button className="px-5 py-2 bg-blue-500 text-white rounded"
                            onClick={() => handleSubmit('create')}>Create</button>
                    </div>)}
                </div>
                )}
        </div>
    );
}